import { lazy, Suspense, useContext } from 'react'
import { WalletReadyContext } from '@/lib/walletContext'

const ColonyProfileComposerInnerLazy = lazy(() => import('@/components/ColonyProfileComposerInner'))

export default function ColonyProfileComposer() {
  const ready = useContext(WalletReadyContext)
  if (!ready) {
    return (
      <p className="rounded-2xl border border-white/10 bg-black/30 p-3 text-center text-xs text-zinc-500">
        Connect this wallet to post on your Colony profile.
      </p>
    )
  }

  return (
    <Suspense
      fallback={(
        <p className="rounded-2xl border border-white/10 bg-black/30 p-3 text-center text-xs text-zinc-500">
          Connect this wallet to post on your Colony profile.
        </p>
      )}
    >
      <ColonyProfileComposerInnerLazy />
    </Suspense>
  )
}
